module.exports = __webpack_public_path__ + "static/media/advantages4.995c721f.svg";